/*
 * Horizon 4.x replaced ThemeEvents.cartUpdate ('cart:update' + CartAddEvent) with the
 * Storefront standard event CartLinesUpdateEvent. The WLD surfaces (cart drawer, product
 * card, search, header) still speak 'cart:update' among themselves. This bridge
 * translates Horizon's buy buttons (product-form-component) back into the 3.5.1 shape:
 * detail = { resource: /cart.js, sourceId: variant id, data: { source, itemCount, productId, didError } }.
 */
import { StandardEvents } from '@shopify/events';

let addRequestId = 0;

document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
  if (!event.promise) return;
  let line = event.lines && event.lines[0];
  let variantId = line && line.merchandiseId ? String(line.merchandiseId).split('/').pop() : undefined;
  const pendingId = event.action === 'add' ? ++addRequestId : null;
  if (pendingId !== null) {
    const quantity = (event.lines || []).reduce(function (total, item) {
      return total + (Number(item.quantity) || 1);
    }, 0);
    document.dispatchEvent(new CustomEvent('cart:add-pending', {
      detail: { requestId: pendingId, variantId: variantId, quantity: quantity || 1 },
    }));
  }

  event.promise
    .then(function (result) {
      let detail = (result && result.detail) || {};
      const cartRequest = detail.ajaxCart && Array.isArray(detail.ajaxCart.items)
        ? Promise.resolve(detail.ajaxCart)
        : fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Cart read failed');
          return response.json();
        });
      return cartRequest.then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: variantId,
                data: {
                  source: detail.source || 'product-form-component',
                  didError: detail.didError === true,
                  itemCount: detail.itemCount,
                  productId: detail.productId,
                  variantId: variantId,
                  sections: detail.sections,
                },
              },
            })
          );
        });
    })
    .catch(function (error) {
      document.dispatchEvent(new CustomEvent('cart:add-failed', { detail: { variantId: variantId } }));
      if (!error || error.name !== 'AbortError') console.warn('[wld-cart-event-bridge]', error);
    })
    .finally(function () {
      if (pendingId !== null) {
        document.dispatchEvent(new CustomEvent('cart:add-settled', { detail: { requestId: pendingId, variantId: variantId } }));
      }
    });
});
